<template>
  <v-container fluid class="login-form fill-height">
    <v-row class="align-center justify-center">
      <v-col cols="12" md="10">
        <v-card class="elevation-1 d-block text-left">
          <v-toolbar dark color="primary" class="elevation-0">
            <v-toolbar-title>Sign in</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <AlertBar
            :value="message.show"
            @input="$emit('show-alert', $event)"
            :type="message.type"
            :message="message.text"
            :detail="message.detail"
          ></AlertBar>
          <v-card-text>
            <v-form @submit.prevent="$emit('login')">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="person"
                    name="userNameField"
                    id="userNameField"
                    label="Email"
                    type="text"
                    :value="email"
                    @input="$emit('email-changed', $event)"
                    :rules="[ rules.required ]"
                    hide-details="auto"
                    placeholder=" "
                    persistent-placeholder
                    autofocus
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="lock"
                    name="passwordField"
                    id="passwordField"
                    label="Password"
                    type="password"
                    :value="password"
                    @input="$emit('password-changed', $event)"
                    :rules="[ rules.required ]"
                    hide-details="auto"
                    placeholder=" "
                    persistent-placeholder                    
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-layout align-right mt-3 pt-3>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  type="submit"
                  name="submitField"
                  id="submitField"
                >Sign in</v-btn>
              </v-layout>
              <v-row>
                <v-col cols="12" class="text-left">
                  <router-link to="/forgot">Forgot password?</router-link>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-divider class="mt-8 pt-8"></v-divider>
         <v-btn                          
            color="success"            
            style="width:50%; min-width:300px;"
            class="pa-8 text-subtitle-1 font-weight-bold"            
            @click.stop="$emit('create-account')"
          >
            Create a free Account
          </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { AlertBar, Rules } from '@itus/ui.common'

export default {
  name: 'SigninForm',
  components: {
    AlertBar  
  },
  data() {
    return {
      rules: Rules
    }
  }, 
  props: {
    email: {
      type: String,
      description: 'Email address'
    },
    password: {
      type: String,
      description: 'Password'
    },
    message: {
      type: Object,
      description: 'Alert message',
      default: function() {
        return {
          show: false,
          type: 'error',
          text: '',
          detail: null
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.forgot-password-link{
  margin-left: 33px;
}
</style>